import blackListDeviceChange from './actions/blackListDeviceChange';
import blackListDeviceCreate from './actions/blackListDeviceCreate';
import blackListDeviceDetail from './actions/blackListDeviceDetail';
import blackListDeviceRemove from './actions/blackListDeviceRemove';
import blackListDevicesList from './actions/blackListDevicesList';
import getBlackListDevices from './getters/getBlackListDevices';
import blackListDevicesUpload from './mutations/blackListDevicesUpload';

const actions = {
    blackListDeviceChange,
    blackListDeviceCreate,
    blackListDeviceDetail,
    blackListDevicesList,
    blackListDeviceRemove
};

const mutations = {
    blackListDevicesUpload
};

const getters = {
    getBlackListDevices
};

export default { actions, mutations, getters };
